import React from 'react';
import { Navigate } from 'react-router-dom';

export default function FamilyProgress() {
  return <Navigate to="/family" replace />;
}
